import axios from 'axios';

const API_URL = 'https://dev-api.thoorigai.net/api/v1/newsletter';

const handleApiError = (error) => {
  if (error.response?.data) {
    return error.response.data;
  }
  return { success: false, message: 'An error occurred' };
};

export const createNewsletterSubscription = async (subscriptionData) => {
  try {
    const response = await axios({
      url: `${API_URL}/create-newsletter-subscription`,
      method: 'POST',
      data: subscriptionData,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getAllNewsletterSubscriptions = async () => {
  try {
    const response = await axios({
      url: `${API_URL}/get-all-newsletter-subscriptions`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getNewsletterSubscriptionById = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/get-newsletter-subscription/${id}`,
      method: 'GET',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteNewsletterSubscription = async (id) => {
  try {
    const response = await axios({
      url: `${API_URL}/delete-newsletter-subscription/${id}`,
      method: 'DELETE',
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const unsubscribeFromNewsletter = async (email) => {
  try {
    const response = await axios({
      url: `${API_URL}/unsubscribe`,
      method: 'POST',
      data: { email },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

const newsletterService = {
  createNewsletterSubscription,
  getAllNewsletterSubscriptions,
  getNewsletterSubscriptionById,
  deleteNewsletterSubscription,
  unsubscribeFromNewsletter,
};

export default newsletterService;
